import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiClient } from '@app/lib/api/api-client';
import { UserAPI } from '@app/lib/api/user/api.user.model';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  apiUrl = environment.API_URL;
  authData = {
    phone_or_email: '',
    area_code: '',
    password: '',
    token: ''
  };
  isNotVerified = false;
  emailNotVerified = '';
  private api: ApiClient;

  constructor(private http: HttpClient) {
    this.api = new ApiClient(http, { responseTimeout: environment.API_TIMEOUT });
  }

  deactivateUser(body: UserAPI.ReasonToLeave): Observable<any> {
    return this.api.user.deactivateUser(body);
  }

  getUserInfo(userId: string): Observable<any> {
    return this.api.user.getUserInfo(userId);
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }

  signUp(data: UserAPI.SignUp): Observable<any> {
    return this.api.user.signUp(data);
  }

  thirdPartySignUp(data: UserAPI.SocialUser): Observable<any> {
    return this.api.user.thirdPartySignUp(data);
  }

  verifyCode(data: UserAPI.VerifyCode): Observable<any> {
    return this.api.user.verifyCode(data);
  }

  sendCode(data: UserAPI.SendCode): Observable<any> {
    return this.api.user.sendCode(data);
  }

  sendOTPCode(data: UserAPI.SendCode): Observable<any> {
    return this.api.user.sendOTPCode(data);
  }

  verifyOTPCode(data: UserAPI.VerifyCode): Observable<any> {
    return this.api.user.verifyOTPCode(data);
  }

  setNewPassword(): Observable<any> {
    return this.api.user.setNewPassword(this.authData);
  }

  confirmPassword(password: string): Observable<boolean> {
    return this.api.user.confirmPassword(password);
  }

  blockUser(userId: string): Observable<any> {
    return this.api.user.blockUser(userId);
  }

  unblockUser(userId: string): Observable<any> {
    return this.api.user.unblockUser(userId);
  }

  isBlockingUser(userId: string): Observable<any> {
    return this.api.user.isBlockingUser(userId);
  }

  isBlockedUser(userId: string): Observable<any> {
    return this.api.user.isBlockedUser(userId);
  }

  getBlockingList(pageNum: number, pageSize: number): Observable<any> {
    return this.api.user.getBlockingList(pageNum, pageSize);
  }

  deleteUser(body: UserAPI.ReasonToLeave) {
    return this.api.user.deleteUser(body);
  }

  undeleteUser() {
    return this.api.user.undeleteUser();
  }

  getTwoFaCode() {
    return this.api.user.getTwoFaCode();
  }

  setUpTwoFaCode() {
    return this.api.user.setUpTwoFaCode();
  }

  removeTwoFa() {
    return this.api.user.removeTwoFa();
  }

  verifyTwoFAOtp(body: UserAPI.VerifyOTPTwoFa) {
    return this.api.user.verifyTwoFaOtp(body);
  }

  changePassword(payload: UserAPI.ChangePassword): Observable<any> {
    return this.api.user.changePassword(payload);
  }

  getModeratorRole(): Observable<UserAPI.ModeratorRole[]> {
    return this.api.user.getModeratorRole();
  }

  getHubList() {
    return this.api.user.getHubList();
  }
}
